const conversionFactors = {
  'Nanometers': 1e-9,
  'Micrometers': 1e-6,
  'Millimeters': 1e-3,
  'Centimeters': 1e-2,
  'Meters': 1,
  'Kilometers': 1e3,
  'Inches': 0.0254,
  'Feet': 0.3048,
  'Yards': 0.9144,
  'Miles': 1609.344,
  'Nautical Miles': 1852,
  'Light Years': 9.461e15,
  'Astronomical Units': 1.496e11,
  'Angstroms': 1e-10,
  'Microns': 1e-6,
  'Mils': 2.54e-5,
  'Fathoms': 1.8288,
  'Furlongs': 201.168,
  'Chains': 20.1168,
  'Rods': 5.0292,
  'Links': 0.201168,
  'Parsecs': 3.086e16
};

export const convertLength = (value, fromUnit, toUnit) => {
  const metersValue = value * conversionFactors[fromUnit];
  const result = metersValue / conversionFactors[toUnit];
  
  // Round the result to a reasonable number of decimal places
  return Number(result.toPrecision(10));
};
